import React from "react";
import { Card, Checkbox, Typography, Row, Col, Tag } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import "./OrderCard.css";

const { Text } = Typography;

const OrderCard = ({dispensingOrder}) => {
  return (
    <Card className="order-card" bordered>
      <div className="card-header">
        <Checkbox style={{ marginRight: 8 }} />
        <div style={{ flex: 1 }}>
          <Text strong>Jackson, Jen</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12 }}>
            1733776989.171-88
          </Text>
        </div>
        <EllipsisOutlined style={{ fontSize: 18, color: "#888" }} />
      </div>

      <Row gutter={16} className="card-details">
        <Col span={8}>
          <Text type="secondary" style={{ fontSize: 10 }}>
            PATIENTS
          </Text>
          <br />
          <Text>Single</Text>
        </Col>
        <Col span={8}>
          <Text type="secondary" style={{ fontSize: 10 }}>
            QUANTITY
          </Text>
          <br />
          <Text>13</Text>
        </Col>
        <Col span={8}>
          <Text type="secondary" style={{ fontSize: 10 }}>
            PRIORITY
          </Text>
          <br />
          <Tag color="red" style={{ fontSize: 12, padding: "0 4px", background: "#fef0f0" }}>
            High
          </Tag>
        </Col>
      </Row>
    </Card>
  );
};

export default OrderCard;
